import { getSafeHarbor } from '../Salesforce/salesforceHelperUtilities';

export const getDeferralType = (
  planDesign,
  tpaMinimumAutoDeferralPercentage,
) => {
  const {
    autoDeferralType: { value: autoDeferralType },
    minimumAutoDeferralPercentage: {
      valueFormatted: minimumAutoDeferralPercentage,
    },
    hasTpa,
    autoEscalateAutoEnrolledDeferrals1perc,
  } = planDesign.questions;
  if (hasTpa.value && tpaMinimumAutoDeferralPercentage === undefined) {
    return 'None';
  }
  const deferralPercentage = hasTpa.value
    ? `${tpaMinimumAutoDeferralPercentage.value}%`
    : minimumAutoDeferralPercentage;
  let autoEscalate;

  if (!hasTpa.value) {
    autoEscalate =
      autoDeferralType === 'FLAT' ? 'Flat Deferral Rate' : 'Auto-Escalate';
  } else {
    autoEscalate =
      autoEscalateAutoEnrolledDeferrals1perc.value === 'no'
        ? 'Flat Deferral Rate'
        : 'Auto-Escalate';
  }

  return `${deferralPercentage} ${autoEscalate}`;
};

export const getServiceEligibility = (elgibility) => {
  switch (elgibility) {
    case 'IMMEDIATE':
      return 'Immediate';
    case 'THREE_MONTHS':
      return 'Three Months';
    case 'TWELVE_MONTHS':
      return '1 Year';
    default:
      return '';
  }
};

export const getTpaFirmName = (tpaFirmName, tpaFirmNameUnlisted) => {
  switch (tpaFirmName.value) {
    case '':
      return tpaFirmNameUnlisted.value;
    default:
      return tpaFirmName.value;
  }
};

export const getFundList = (investmentLineup) => {
  switch (investmentLineup.value) {
    case 'fundLineup1':
      return 'Simply Fund Lineup 1';
    case 'fundLineup2':
      return 'Simply Fund Lineup 2';
    case 'fundLineupOneDigital':
      return 'OneDigital Fund Lineup';
    default:
      return 'Simply Fund Lineup 3';
  }
};

export const getFirmName = (
  role,
  hasFp,
  hasTpa,
  firmNameFreeForm,
  tpaFirmName,
  firmNameUnlisted,
) => {
  if (hasFp.value) {
    if (role === 'advisor' || role === 'employer') {
      return firmNameFreeForm;
    }
  }
  if (hasTpa.value) {
    if (role === 'tpa') {
      return tpaFirmName.value === 'myFirmIsntListed'
        ? firmNameUnlisted
        : tpaFirmName.value;
    }
  }
  return '';
};

export const getSafeHarborDiscretionaryMatchContType = (
  safeHarbor,
  planUsingSafeHarbor,
  employerMatch,
  whichSafeHarbor,
  stretchSafeHarbor,
  hasTpa,
  employerContributionMatch,
) => {
  const pardotData = {};

  if (employerContributionMatch === 'yes') {
    pardotData.contribution_type = safeHarbor;
  } else {
    pardotData.contribution_type = 'No Employer Contributions';
    pardotData.safe_harbor = 'None';
    pardotData.discretionary_match_formula = 'None';
  }
  if (safeHarbor === 'nonSafeHarbor' || planUsingSafeHarbor.value === 'no') {
    pardotData.discretionary_match_formula =
      employerMatch !== '' ? employerMatch : 'None';
    pardotData.safe_harbor = 'None';
  } else if (
    safeHarbor === 'safeHarbor' ||
    planUsingSafeHarbor.value === 'yes'
  ) {
    if (hasTpa.value) {
      pardotData.safe_harbor = getSafeHarbor(whichSafeHarbor.value);
      pardotData.discretionary_match_formula = 'None';
    } else {
      pardotData.safe_harbor =
        stretchSafeHarbor === 'Stretch your match'
          ? 'Basic Match (100% of 1st 3%+50% of next 2%)'
          : '4% Enhanced Match';
      pardotData.discretionary_match_formula = '';
    }
  }
  return pardotData;
};
